module.exports = __webpack_public_path__ + "img/vannkraft_paavirkning_vannuttak_overfoering_dammer.9e46b49e.jpg";